module.exports = __webpack_public_path__ + "img/thumbnail_NorthIslandBrownKiwi_m_normal.3df3aad9.png";